export default requester => {
    return {
        /**
         * Get user files
         *
         * @param {object} params Query parameters
         * @return {object}
         */
        list(params = {}) {
            return requester.get('/content/attachments/files', { params });
        },

        /**
         * Delete a file
         *
         * @param {string} fileId File ID
         * @return {object}
         */
        delete(fileId) {
            return requester.delete(`/content/attachments/files/${fileId}`);
        },

        /**
         * Rename a file
         *
         * @param {string} fileId File ID
         * @param {object} payload Update data
         * @return {object}
         */
        update(fileId, payload) {
            return requester.put(`/content/attachments/files/${fileId}`, payload);
        },

        /**
         * Get file details
         *
         * @param {string} fileId File ID
         * @return {object}
         */
        get(fileId) {
            return requester.get(`/content/attachments/files/${fileId}`);
        },

        /**
         * Upload a new file
         *
         * @param {File} file File object
         * @param {object} params Additional parameters
         * @param {object} options Upload options
         * @return {object}
         */
        async upload(file, params = {}, { onUpdateProgress = () => {} } = {}) {
            try {
                const payload = { name: file.name, type: file.type, size: file.size, ...params };
                const { data } = await requester.post('/content/attachments/upload', payload);

                if (!data) {
                    throw new Error('No data');
                }

                const { fileKey, signedUrl } = data;

                await requester.put(
                    signedUrl,
                    file,
                    {
                        headers: {
                            'Content-Type': file.type,
                        },
                        onUploadProgress: (event) => {
                            const progress = Math.round((event.loaded * 100) / event.total);
                            onUpdateProgress(progress);
                        },
                    }
                );

                return { ...payload, fileKey };
            } catch (err) {
                throw err;
            }
        }
    };
} 